import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const { vendorsSuccess } = isOfflineDev ? await import("../tests/fixtures/purchaseOrders") : {};

export async function getPurchaseOrdersQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/purchaseorders/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getPurchaseOrderRowsById(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/id?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function getPurchaseOrdersRowsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/purchaseorders/row/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getVendors(headers) {
  if (import.meta.env.VITE_OFFLINE_DEV !== "true") {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/vendors`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
      .catch(() => { return res })
    )
  }
  else return vendorsSuccess
}

export async function postPurchaseOrdersCreate(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/purchaseorders/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postPurchaseOrdersAddRow(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/purchaseorders/row/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getPOStates(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/states?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function putPurchaseOrderEdit(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/edit?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function getPurchaseOrderEditableFields(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/editable_fields?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function getPurchaseOrderRowEdit(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/row/editable_fields?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function putPurchaseOrderRowEdit(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/row/edit?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function deletePurchaseOrderRow(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/row/delete?id=${id}`, {
    method: 'DELETE',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function getReceiptsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/purchaseorders/receipts/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getReceiptRowsById(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/receipt/rows/id?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function postReceiptCreate(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/purchaseorders/receipt/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postReceiptAddRow(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/purchaseorders/receipt/row/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getReceiptStates(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/receipt/states?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function putReceiptEdit(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/receipt/edit?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function getReceiptEdit(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/receipt/edit?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function getReceiptRowEdit(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/receipt/row/edit?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function putReceiptRowEdit(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/receipt/row/edit?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}

export async function deleteReceiptRow(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/purchaseorders/receipt/row/delete?id=${id}`, {
    method: 'DELETE',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
    .catch(() => { return res })
  )
}